import React, { useState } from "react";
import { Flex, Modal } from "antd";
import { ArrowLeftOutlined, DeleteOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import HButton from "../../../components/custom/input/button/Button";
import { useWorkflowStore } from "../store";
import { selectSelectedStep } from "../store/selectors";
import { DeleteComponent } from "../../utils/CommonVessels";

const DELETE_STEP_CONFIRM_TITLE = "Delete this step?";
const DELETE_STEP_CONFIRM_CONTENT =
    "This step will be removed from the rule. You can add it back later if needed.";

export interface ConfigPanelFooterProps {
    primaryLabel?: string;
    onPrimaryClick?: () => void;
    primaryDisabled?: boolean;
    isPlaceholder?: boolean;
    hideDelete?: boolean;
    onBackToPicker?: () => void;
    backOnly?: boolean;
}

export const ConfigPanelFooter: React.FC<ConfigPanelFooterProps> = ({
    primaryLabel,
    onPrimaryClick,
    primaryDisabled = false,
    isPlaceholder = false,
    hideDelete = false,
    onBackToPicker,
    backOnly = false,
}) => {
    const selectedStep = useWorkflowStore(selectSelectedStep);
    const deleteStep = useWorkflowStore((s) => s.deleteStep);
    const selectNode = useWorkflowStore((s) => s.selectNode);

    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);

    const handleBackClick = () => {
        if (onBackToPicker) {
            onBackToPicker();
            return;
        }
        if (isPlaceholder && selectedStep?.id) {
            deleteStep(selectedStep.id);
        }
        selectNode(null);
    };
    const handleDeleteClick = () => setShowDeleteConfirm(true);
    const handleDeleteConfirm = async () => {
        if (!selectedStep) return;
        setConfirmLoading(true);
        deleteStep(selectedStep.id);
        setShowDeleteConfirm(false);
        setConfirmLoading(false);
    };
    const handleDeleteCancel = () => setShowDeleteConfirm(false);

    const showLeftButton = !hideDelete || backOnly;
    const showBack = showLeftButton && (backOnly || isPlaceholder);
    const showDelete = showLeftButton && !backOnly && !isPlaceholder;
    const showPrimary = !backOnly && primaryLabel != null && onPrimaryClick != null;

    return (
        <>
            <Flex className="trigger-rule-config-panel-footer justify-content-between gap-3 flex-wrap">
                {showBack && (
                    <HButton variant="cancel" prefixIcon={<ArrowLeftOutlined />} onClick={handleBackClick}>
                        Back
                    </HButton>
                )}
                {showDelete && (
                    <HButton
                        variant="cancel"
                        prefixIcon={<DeleteOutlined />}
                        onClick={handleDeleteClick}
                        buttonClassName="hs-btn-outline-danger"
                    >
                        Delete Step
                    </HButton>
                )}
                {showPrimary && (
                    <HButton type="primary" onClick={onPrimaryClick} disabled={primaryDisabled}>
                        {primaryLabel}
                    </HButton>
                )}
            </Flex>
            <DeleteComponent
                modalOpen={showDeleteConfirm}
                setModalOpen={setShowDeleteConfirm}
                record={null}
                confirmDeleteIcon="hs-delete-icon"
                confirmDeleteBtnName="Delete"
                confirmDeleteComponentTitle={DELETE_STEP_CONFIRM_TITLE}
                confirmDeleteComponent={DELETE_STEP_CONFIRM_CONTENT}
            />
        </>
    );
};
